import { Box, DialogContent, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import KSimHeader from '../../k-sim-header/KSimHeader';
import { ExerciseType } from '../../types';
import { ExerciseFormData } from './CreateExerciseDialog';

export type CautionStepProps = UseFormReturn<ExerciseFormData> & {
  actions: ReactNode;
  handleNext: SubmitHandler<ExerciseFormData>;
  stepper?: ReactNode;
};

const CautionStep = ({ actions, handleNext, handleSubmit, stepper }: CautionStepProps) => (
  <Box component="form" onSubmit={handleSubmit(handleNext)} sx={{ display: 'contents' }}>
    <DialogContent>
      {stepper}
      <KSimHeader exerciseType={ExerciseType.Classroom} mobileOnly sx={{ height: '153px' }} />
      <Typography component="p" my={5}>
        We invite you to explore the new functionality allowing multiple students to simulate together in a common
        exercise. This functionality is offered as an early preview to you to allow you to test out the latest
        innovations we are creating. Please be aware that there are still several limitations and errors may happen. But
        we still believe that you will appreciate the preview. For now, this functionality is only available for the
        K-Sim Navigation Cloud simulator.
      </Typography>
    </DialogContent>
    {actions}
  </Box>
);

export default CautionStep;
